@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.subtotal-container {
  border-top: 1px solid @cost-review-item--subtotal--border-color;
  display: flex;
  justify-content: flex-end;
  font-size: 13px;
  padding: 10px 0;
  font-weight: @bold;
  margin: 0 35px;
}
